import Index from './Index.vue';
import Search from './Search.vue';
import Vehicles from './Vehicles.vue';
import Passengers from './Passengers.vue';
import Addresses from './Addresses.vue';
import Options from './Options.vue';
import Summary from './Summary.vue';
import OrderConfirmation from './OrderConfirmation.vue';
import PaymentError from './PaymentError.vue';
import Confirmation from './Confirmation.vue';

export default {Index, Search, Vehicles, Passengers, Addresses, Options, Summary, OrderConfirmation, PaymentError, Confirmation};
